// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"2d67e0bd","272":"e1360128","378":"e982b36d","400":"5750e43b","704":"789433ef","716":"c6008cdf","893":"5a7adbf1"}[chunkId] + ".chunk.js";
};